import React from "react";
import { Text, Box, SimpleGrid, Skeleton, Flex, Button } from "@chakra-ui/react";
import { times } from "lodash";
import { useHits, type UseHitsProps, useSearchBox } from "react-instantsearch";
import { Integration, type IntegrationRecord } from "./integration";

const transformItems: UseHitsProps<IntegrationRecord>["transformItems"] = (items, { results }) => {
  if (results?.query?.length === 0) {
    return items.filter((item) => item.status !== "shadow");
  }

  return items;
};

type ResultsProps = {
  // eslint-disable-next-line react/boolean-prop-naming
  noFilters: boolean;
};

function IntegrationsSearchResults({ noFilters }: ResultsProps) {
  const { hits, results, sendEvent } = useHits<IntegrationRecord>({ transformItems });
  const { clear } = useSearchBox();

  if (results?.nbHits === 0) {
    // Algolia doesn't have a specific loading state, so we infer the loading state from the fact that
    // destinations should never be empty if the category is all and there is no search
    if (noFilters && !results?.query) {
      return (
        <SimpleGrid columns={[1, 2, 2, 3, 3]} spacing={7}>
          {times(12).map((i) => (
            <Skeleton key={i} height="172px" endColor="base.background" />
          ))}
        </SimpleGrid>
      );
    }

    return (
      <>
        <Text textStyle="h4">No results found</Text>
        <Flex as={Text} align="center" gap={1} mt={4}>
          <Button
            variant="unstyled"
            fontSize="lg"
            textDecoration="underline"
            textUnderlineOffset={3}
            _hover={{ color: "grass " }}
            onClick={clear}
          >
            Reset your filters
          </Button>{" "}
          <Text as="span" fontSize="lg">
            to continue exploring.
          </Text>
        </Flex>
      </>
    );
  }

  return (
    <Box pb={8}>
      <SimpleGrid as="ul" columns={[1, 2, 3, 3, 3]} spacing={7} listStyleType="none">
        {hits
          ?.filter((hit) => hit.status !== "shadow")
          .map((hit) => (
            <Box key={hit.objectID} as="li">
              <Integration hit={hit} onSendEvent={sendEvent} />
            </Box>
          ))}
        {hits
          ?.filter((hit) => hit.status === "shadow")
          .map((hit) => (
            <Box key={hit.objectID} as="li">
              <Integration hit={hit} onSendEvent={sendEvent} />
            </Box>
          ))}
      </SimpleGrid>
    </Box>
  );
}

export default IntegrationsSearchResults;
